export const datePickerErrors = (state: any, schema: any) => {
    if (schema.is_required && !state) {
        return {
            message: 'errors.validation.fieldRequired',
            values: {}
        }
    }
}
